var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { BreadcrumbsItem } from './breadcrumbs-item';
import { ChevronRightIcon } from '../icon';
export var Breadcrumbs = React.forwardRef(function (_a, ref) {
    var items = _a.items, children = _a.children, rootProps = __rest(_a, ["items", "children"]);
    return (React.createElement(MuiBreadcrumbs, __assign({}, rootProps, { ref: ref, separator: React.createElement(ChevronRightIcon, { size: "1em" }) }), items ? items.map(function (item, i) { return React.createElement(BreadcrumbsItem, __assign({ key: i }, item)); }) : children));
});
